import useHttp from './use-http';

// @ts-ignore
const usePayoutMethods = () => {
    const issuePhysicalGrinCard = (contactId, addressData) => {
        const url = `/api/v1/contacts/${contactId}/payout-methods/physical-card`;
        const { http } = useHttp();
        return http.post(url, {
            shipping_name: addressData.name,
            shipping_address_line1: addressData.street,
            shipping_address_line2: addressData.street_2 ?? null,
            shipping_address_city: addressData.city,
            shipping_address_state: addressData.state_code,
            shipping_address_country: addressData.country_code,
            shipping_address_zip: addressData.zip
        });
    };

    const editPhysicalGrinCard = (contactId, payoutMethodId, isDefault) => {
        const url = `/api/v1/contacts/${contactId}/payout-methods/physical-card/${payoutMethodId}`;
        const { http } = useHttp();
        return http.patch(url, {
            is_default: isDefault
        });
    };

    const addVerifiedDebitCard = (contactId, token, isDefault) => {
        const url = `/api/v1/contacts/${contactId}/payout-methods/verified-card`;
        const { http } = useHttp();
        return http.post(url, {
            token,
            is_default: isDefault
        });
    };

    const editVerifiedDebitCard = (contactId, payoutMethodId, payload) => {
        const url = `/api/v1/contacts/${contactId}/payout-methods/card/${payoutMethodId}`;
        const { http } = useHttp();
        return http.patch(url, {
            expiration_month: payload.expiration_month,
            expiration_year: payload.expiration_year,
            holder_name: payload.holder_name,
            billing_address_zip: payload.billing_address_zip,
            is_default: payload.is_default
        });
    };

    const addBankAccount = (contactId, payload) => {
        const url = `/api/v1/contacts/${contactId}/payout-methods/bank-account`;
        const { http } = useHttp();
        return http.post(url, payload);
    };

    const editBankAccount = (contactId, payoutMethodId, isDefault) => {
        const url = `/api/v1/contacts/${contactId}/payout-methods/bank-account/${payoutMethodId}`;
        const { http } = useHttp();
        return http.patch(url, {
            is_default: isDefault
        });
    };

    const deletePayoutMethod = (contactId, payoutMethodId) => {
        const url = `/api/v1/contacts/${contactId}/payout-methods/${payoutMethodId}`;
        const { http } = useHttp();
        return http.delete(url);
    };

    return {
        issuePhysicalGrinCard,
        editPhysicalGrinCard,
        addVerifiedDebitCard,
        editVerifiedDebitCard,
        addBankAccount,
        editBankAccount,
        deletePayoutMethod
    };
};

export default usePayoutMethods;
